import type { FCIError } from "@searchui-searchforms/shared/fci";
import { FCI_ENDPOINT, FCI_IDENTITY } from "@searchui-searchforms/shared/fci";
import { enhancedFetch } from "@/shared/utils/enhancedFetch";

export interface LogArgs {
    errorType: FCIError;
    errorInfo: string;
    details?: Record<string, string | number | boolean | undefined>;
}

export const logFCI = (args: LogArgs) => {
    const { errorType, errorInfo, details } = args;

    const body = {
        ErrorType: errorType,
        ErrorInfo: errorInfo,
        Page: window.location.pathname,
        ...FCI_IDENTITY,
        ...(details ?? {}),
    };

    enhancedFetch(FCI_ENDPOINT, {
        method: "POST",
        body,
    });

    console.error("FCI", body);
};
